import axios from "axios"
import { useAuth0 } from "@auth0/auth0-react"
import { useQuery } from "@tanstack/react-query"
import { usePermissionsList } from "./queries/usePermissions"
import { getDateFormatted, getDateTomorrow } from "../utils/generalUtils"

// Canonical window: 30 days starting tomorrow. Must stay in sync with the
// oncare-server defaults (controllers/futureHuddleController) and the Python
// Lambda's WINDOW_DAYS (infusion-optimizer/Lambda_SFTP/src/sftp_pull_live.py).
const useFetchFutureHuddle = (numDays = 30) => {
	const { getAccessTokenSilently, isAuthenticated, user } = useAuth0()
	const permissionsData = usePermissionsList()
	const canRead = permissionsData?.includes("read:schedules") ?? false
	const testEnvironment = user?.org_id === "org_lkg3WMhi3Q2l92iT"

	const query = useQuery({
		queryKey: ["future-huddle", numDays, testEnvironment],
		queryFn: async () => {
			const token = await getAccessTokenSilently({
				authorizationParams: { audience: process.env.REACT_APP_API_IDENTIFIER }
			})
			const tomorrow = getDateFormatted(getDateTomorrow(testEnvironment))
			const response = await axios.get(
				`${process.env.REACT_APP_BACKEND_URL}/api/future-huddle?date=${tomorrow}&numDays=${numDays}`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			if (!Array.isArray(response.data.payload)) {
				throw new Error("future-huddle response payload is not an array")
			}
			return response.data.payload
		},
		enabled: isAuthenticated && canRead,
		staleTime: 1000 * 60 * 5,
		refetchOnMount: "always"
	})

	return {
		futureHuddleData: query.data ?? [],
		futureHuddleStatus: query.isLoading
			? "loading"
			: query.isError
				? "failed"
				: query.data
					? "succeeded"
					: "idle",
		futureHuddleError: query.error?.message ?? null
	}
}

export default useFetchFutureHuddle
